import { useMutation } from 'react-query';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { AxiosError } from 'axios';
import arrayBufferParse from '@/utils/functions/arrayBufferParse';
import { getWorkOrderMigration } from './work-order-migration-consult.services';

interface Report {
  timestamp: string;
  status: number;
  error: string;
  path: string;
  message: string;
}

export function useWorkOrderMigrationReport() {
  return useMutation(getWorkOrderMigration, {
    onSuccess() {
      notification.success({
        message: 'Relatório de orçamentos migrados gerado com sucesso!',
      });
    },

    onError(error: AxiosError<Report>) {
      const response = arrayBufferParse<Report>(error.response?.data);

      notificationError(response);
    },
  });
}
